import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Utils } from "../../utils/ApplicationUtils";
import { Link } from "react-router-dom";


const GNBPURE00001S = () => {
  const { doAction } = useApplicationCommon(); // ✅ `doAction`만 사용
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태
  const [co_rpsr_nm, setco_rpsr_nm] = useState([]);           // 대표이사
  const [co_yy, setco_yy] = useState([]);                     // 연도
  const [co_capl, setco_capl] = useState([]);                 // 자본금
  const [prmry_bsns_cntn, setprmry_bsns_cntn] = useState([]); // 주요사업
  const [exstf_cnt, setexstf_cnt] = useState([]);             // 임직원수
  const [co_sls, setco_sls] = useState([]);                   // 매출액

const goSearch = () => {
    const actionForm = {
      txGbnCd: "srchcoInfoDetail",
      
    };
      
    doAction("COM0001SC", actionForm, (resData) => {
      if (resData.APP_HEADER.respCd === "N00001") {
        setco_rpsr_nm(resData.co_rpsr_nm);
        setco_yy(resData.co_yy);
        setco_capl(Utils.format(resData.co_capl,'manwon'));
        setprmry_bsns_cntn(resData.prmry_bsns_cntn);
        setexstf_cnt(resData.exstf_cnt);
        setco_sls(Utils.format(resData.co_sls,'manwon'));
        
      }
    });
};


const memoizedGoSearch = useCallback(goSearch, []);
  // ✅ 최초 조회
  useEffect(() => {
    goSearch();
  }, [memoizedGoSearch]);
  
  


  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type01">
          <h2>기업소개</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>ABOUT US<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE00000S">CEO인사말</Link></li>
                <li><Link to="/GNBPURE00001S">ABOUT US</Link></li>
                <li><Link to="/GNBPURE03001S">우리회사소식</Link></li>
                <li><Link to="/GNBPURE00002S">사업실적</Link></li>
                <li><Link to="/GNBPURE00003S">오시는길</Link></li>
              </ul>
            </li>
          </ul>
        </div>

        <div id="cont" className="cont">
          <div className="inner">
            <h3>ABOUT US</h3>
            
            <article className="mt40">
               {/* GnB & Pure 관계 설명 */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "20px", padding: "20px" }}>
              <img src="/asset/img/common/logo_c.png" style={{ width: "30%", height: "auto",marginBottom:"30px", marginRight: "40px" }}/>
              <img src="/asset/pure/img/common/logo_c.png" style={{ width: "30%", height: "auto", marginBottom:"30px" }} />
              </div>
              <p className="subtitle" style={{ textAlign: "center" }}>서로를 이해하고 함께 나아가는,  <strong style={{ color: "#0586b9", fontWeight: "bold" }}>
                        우리는 하나의 가족 </strong>입니다.</p>

            </article>

              <h2>회사개요({co_yy})</h2>
              <div className="table-type table-row mo">
                <table className="info-table">
                <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "auto" }} />
                    
                  </colgroup>
                <tbody> 
                  <tr>
                    <th><span className="diamond"></span>설립일</th>
                    <td>2005년 10월 19일</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>대표이사</th>
                    <td>{co_rpsr_nm}</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>자본금</th>
                    <td>{co_capl}만 원</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>주요사업</th>
                    <td>{prmry_bsns_cntn}</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>매출액</th>
                    <td>{co_sls}만 원</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>본사</th>
                    <td>서울특별시 서초구 양재동 215 하이브랜드 15층 1519호</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>임직원</th>
                    <td>{exstf_cnt}명</td>

                  </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-type table-row pc">
                <table className="info-table">
                <colgroup>
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "35%" }} />
                  </colgroup>
                <tbody> 
                  <tr>
                    <th><span className="diamond"></span>설립일</th>
                    <td>2005년 10월 19일</td>
                    <th><span className="diamond"></span>대표이사</th>
                    <td>{co_rpsr_nm}</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>자본금</th>
                    <td>{co_capl}만 원</td>
                    <th><span className="diamond"></span>주요사업</th>
                    <td>{prmry_bsns_cntn}</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>매출액</th>
                    <td>{co_sls}만 원</td>
                    <th><span className="diamond"></span>본사</th>
                    <td>서울특별시 서초구 양재동 215 하이브랜드 15층 1519호</td>
                  </tr>
                  <tr>
                    <th><span className="diamond"></span>임직원</th>
                    <td colSpan="3">{exstf_cnt}명</td>

                  </tr>
                  </tbody>
                </table>
              </div>
          </div>

          <div className="inner">
            <h3>회사이념</h3>
            <article>
              <p className="subtitle">
                명실상부한 정보화 사회를 리드하는 <br />
                GnB & Pure
              </p>

              <p>
                중, 소형 금융기관에 정통한 전문 SI회사 GnB & Pure입니다.
              </p>

              <div className="ide_wrap">
                <ul className="ide_inner01">
                  <li className="txt-tit05 ide-img">
                    <span>GnB & Pure</span>는 전문회사입니다.
                  </li>
                  <li>
                    저축은행을 비롯함 중소형 금융기관에 정통한 <br /> 전문 SI회사로, 저축은행 업계에 MultiBank를 <br /> 1 Application으로 지원할 수 있는, 명실상부한 통합 <br /> 차세대뱅킹 시스템을 최초로 구축한	기업입니다.
                  </li>
                </ul>

                <ul className="ide_inner02">
                  <li className="txt-tit05 ide-img">
                    <span>GnB & Pure</span>는 소중히 여깁니다.
                  </li>
                  <li>
                    저축은행, 보험사, 여신전문기관의 업무 프로세스 <br /> 관련 전문가적 지식과 경험을 보유한 분야별 업종 전문가와 <br /> 차세대 선진금융 기술력을 보유한 최상의 <br /> 개발인력 Man Power는 GnB & Pure 최고의 자산입니다.
                  </li>
                </ul>

                <ul className="ide_inner03">
                  <li className="txt-tit05 ide-img">
                    <span>GnB & Pure</span>는 지향합니다.
                  </li>
                  <li>
                    선진 금융기술을 바탕으로 철저히 중소형 금융기고나 <br /> 환경 중심의 고객사 1:1 Total맞춤 IT서비스를 지향하며 <br /> 이를 위해 고객사에 ASP, SI, Outsourcing 등 다양한 <br /> 방식으로 최상의 IT서비스를 제공합니다.
                  </li>
                </ul>

              </div>
            </article>
          </div>

          <div className="inner">
            <h3>비전</h3>
            <article>
              <p className="subtitle">
                고객이 스스로 찾아주는<br />
                국내 초일류 기술 PROVIDER
              </p>

              <div className="vis_img">
                <img src="../../asset/img/subA/img_vis.png" alt="지앤비소프텍 비전" className="pc" />
                <img src="../../asset/img/subA/img_vis_mo.png" alt="지앤비소프텍 비전" className="mo" />
              </div>

            </article>

            <article className="mt40">
              <p className="subtitle">경영목표</p>


              <div className="vis_img">
                <img src="../../asset/img/subA/img_manage.png" alt="지앤비소프텍 경영목표" className="pc" />
                <img src="../../asset/img/subA/img_manage_mo.png" alt="지앤비소프텍 경영목표" className="mo" />
              </div>


            </article>
          </div>

          <div className="inner">
            <h3>조직도</h3>
            <div>
              <img src="../../asset/img/subA/img_org.png" alt="조직도" className="pc" />
              <img src="../../asset/img/subA/img_org_mo.png" alt="조직도" className="mo" />
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE00001S;